// extracted by mini-css-extract-plugin
module.exports = {"modal":"AssignDevicesModal_modal__2UkQK","form":"AssignDevicesModal_form__1ksUZ","btnWrapper":"AssignDevicesModal_btnWrapper__3aw8F","spacer":"AssignDevicesModal_spacer__7G9oS"};